export const ExpedienteEntity = {
    id: null,
    expediente: '',
    tipoFalta: '',
    sancion: '',
    observacion: '',
    estado: 'INGRESADO',
    fecRegistro: new Date(),
    fecSancion: new Date(),
    fecPrescripcion: new Date(),
    persona: {
        id: null, 
        nombres: '', 
        apellidos: '', 
        docIdentidad: '' 
    },
};